// src/components/SessionExpiredModal.jsx
// Re-login sobre la pantalla actual cuando la sesión terminó de verdad
// (refresh rechazado o token inválido — ver api.js). Se monta globalmente en
// App.js, igual que TermsReacceptModal.
//
// Existe para no perder lo cargado: antes un 401 recargaba la página y el
// usuario volvía al landing sin mensaje y sin su formulario. Acá la página
// sigue montada debajo; después de ingresar, el usuario reenvía a mano.

import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const font = 'Montserrat, sans-serif';

export default function SessionExpiredModal() {
  const { user, sessionExpired, login, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState(null); // null = todavía no tocó el campo → su email
  const [password,   setPassword]   = useState('');
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState('');

  if (!sessionExpired || !user) return null;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(identifier ?? user.email, password);
      setPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo ingresar. Intentá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const handleSalir = () => {
    logout();
    navigate('/');
  };

  const input = {
    width: '100%', boxSizing: 'border-box', padding: '10px 14px', marginBottom: 12,
    border: '1px solid #cfdbe3', borderRadius: 10,
    fontFamily: font, fontSize: 13.5, color: '#163244', outline: 'none',
  };

  return (
    <div role="dialog" aria-modal="true" aria-labelledby="fixo-sesion-titulo" style={{
      position: 'fixed', inset: 0, zIndex: 10000,
      background: 'rgba(15, 34, 51, 0.75)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div style={{
        background: '#ffffff', borderRadius: 16, boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
        maxWidth: 420, width: '100%', overflow: 'hidden',
      }}>
        <div style={{ background: '#163244', padding: '20px 24px 18px', borderBottom: '3px solid #E7A432' }}>
          <div id="fixo-sesion-titulo" style={{ fontFamily: font, fontSize: 15, fontWeight: 800, color: '#ffffff' }}>
            Tu sesión se cerró
          </div>
          <div style={{ fontFamily: font, fontSize: 11.5, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>
            Ingresá de nuevo para continuar. Lo que cargaste sigue acá.
          </div>
        </div>

        <form onSubmit={handleLogin} style={{ padding: '22px 24px' }}>
          <input
            type="text" autoComplete="username" placeholder="Email o usuario"
            value={identifier ?? user.email ?? ''} onChange={e => setIdentifier(e.target.value)}
            style={input}
          />
          <input
            type="password" autoComplete="current-password" placeholder="Contraseña" autoFocus
            value={password} onChange={e => setPassword(e.target.value)}
            style={input}
          />

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8,
              padding: '10px 14px', fontFamily: font, fontSize: 12.5, color: '#dc2626', marginBottom: 12,
            }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading || !password} style={{
            width: '100%', padding: '12px 0', marginBottom: 10,
            background: loading || !password ? 'rgba(22,50,68,0.5)' : '#163244',
            color: '#ffffff', border: 'none', borderRadius: 50,
            cursor: loading || !password ? 'not-allowed' : 'pointer',
            fontFamily: font, fontSize: 13, fontWeight: 700,
          }}>
            {loading ? 'Ingresando…' : 'Ingresar'}
          </button>

          <button type="button" onClick={handleSalir} disabled={loading} style={{
            width: '100%', padding: '10px 0', background: 'transparent', color: '#7a93a4',
            border: '1px solid rgba(0,0,0,0.1)', borderRadius: 50, cursor: 'pointer',
            fontFamily: font, fontSize: 12, fontWeight: 500,
          }}>
            Salir
          </button>
        </form>
      </div>
    </div>
  );
}
